var API_DOMAIN = "https://hemnathbilliing.zentexus.com/api";
//var API_DOMAIN = "http://localhost/hemanathbilling/api";
export default API_DOMAIN;
